import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DataSharingTokenService } from "../../service/data-sharing-token.service";
import { ErrorUtility } from "../../utility/error-utility";

@Component({
    selector: 'accept-data-sharing-token-dialog',
    template: require('./accept-data-sharing-token-dialog.component.html'),
})
export class AcceptDataSharingTokenDialogComponent {

    error: string;
    hasActiveFlatSubscription: boolean;
    confirm: boolean;
    code: string;
    accepting: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<AcceptDataSharingTokenDialogComponent>,
        @Inject(forwardRef(() => DataSharingTokenService)) private dataSharingTokenService: DataSharingTokenService,
        @Inject(MAT_DIALOG_DATA) data
    ) { this.hasActiveFlatSubscription = data.hasActiveFlatSubscription }


    save(): void {
        if (this.hasActiveFlatSubscription && !this.confirm) {
            this.confirm = true;
        } else {
            this.doAccept();
        }
    }

    private doAccept(): void {
        this.error = null;
        this.accepting = true;
        this.dataSharingTokenService.accept(this.code).then(() => this.dialogRef.close(true)).catch(err => {
            this.confirm = false;
            this.accepting = false;
            this.error = ErrorUtility.getMessage(err)
        });
    }
}